import { DcrEntityType } from '@/core/graphql/generated/types';

import { useHcoFieldNames } from '../_hooks/useHcoFieldNames';
import { useHcpFieldNames } from '../_hooks/useHcpFieldNames';

export const DCRFieldName = ({
	field,
	type,
	countryId
}: {
	field: string;
	type: DcrEntityType;
	countryId?: string | null;
}) => {
	const { hcpFieldNames } = useHcpFieldNames(countryId);
	const { hcoFieldNames } = useHcoFieldNames();

	if (type === DcrEntityType.Hcp) {
		return <>{hcpFieldNames[field as keyof typeof hcpFieldNames] || field}</>;
	}

	return <>{hcoFieldNames[field as keyof typeof hcoFieldNames] || field}</>;
};
